import { v4 } from "uuid";

export const cloneObject = (object) => {
  const clonedObjectWithoutId = JSON.parse(JSON.stringify(object));
  return { ...clonedObjectWithoutId, id: v4() };
};
